import { render, staticRenderFns } from "./Forget_step_2.vue?vue&type=template&id=985fca0c&scoped=true"
import script from "./Forget_step_2.vue?vue&type=script&lang=js"
export * from "./Forget_step_2.vue?vue&type=script&lang=js"
import style0 from "./Forget_step_2.vue?vue&type=style&index=0&id=985fca0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985fca0c",
  null
  
)

export default component.exports